var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-mail"},[_c('v-text-field',{attrs:{"label":"Search Email","placeholder":"Search Email","solo":"","append-icon":"search"},on:{"input":_vm.onSearchEmail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }